export default __webpack_public_path__ + "static/logo-bpress-stainless-steel-466369ff577fa47f143ef189be5eb452.svg";